/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as React from 'react'
import { Formik, Form, FormikProps } from 'formik'
import { debounce } from 'debounce'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import Visibility from '@material-ui/icons/Visibility'
import Slide from '@material-ui/core/Slide'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import {
  CardHeader,
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core'
import {
  ChecklistPhotoList,
  IChecklist,
  IChecklistField,
  IChecklistRenderProps,
  IChecklistTicketJson,
  IPhoto
} from '../../../models/Checklist'
import {
  IImageStorage,
  STORED_IMAGE_PREFIX
} from '../../../data_sources/imagestorage/imageStorage'
import {
  getSiteFranchiseeId,
  IAttribute,
  IFranchisee,
  IFranchisees,
  ISite,
  ISites,
  ITag
} from '../../../models/Franchise'
import { LoadStatus, SaveStatus } from './HSTicketsTab'
import { SelectOptions } from '../../form_controls/types'
import {
  convertSelectedResolverIdsToResolvers,
  IEditTicketFields,
  IStoredTicket,
  ITicket,
  ITicketCategories,
  ITicketCategory,
  ITicketCategoryType,
  ITicketUpdate,
  PriorityOption,
  TicketStatus
} from '../../../models/Ticket'
import SubmitStatusDialog, {
  SubmitDialogStage
} from '../../common/SubmitStatusDialog'
import { AssigneeType } from '../../../types'
import { IChecklistConditionalRule } from '../../../models/ConditionalRule'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../../OneplaceLibraryProvider'
import { formatDate } from '../../../utils/dates'
import { logError } from '../../../logging'
import {
  getRenderProps,
  refreshFormulaQuestions,
  updateQuestionNumbers
} from '../../checklists/utils/getRenderProps'
import { CONFIG } from '../../../config'
import { validateGroups } from '../../checklists/utils/validateChecklist'
import { deepCopy } from '../../../utils'
import {
  findChecklistGroupById,
  hasConditionApplied,
  isConditionalRuleShow,
  updateDynamicDatalistQuestions
} from '../../checklists/utils/conditionalQuestion'
import { UserFacingError } from '../../../errors/UserFacingError'
import { NetworkError } from '../../../errors/NetworkError'
import AssignmentForm, { IAssignment } from '../../common/AssignmentForm'
import TabsComponent, { ITabDefinition } from '../../common/Tabs'
import { PageLoader } from '../../common/PageLoader'
import SelectControl from '../../form_controls/SelectControl'
import { PriorityControl } from '../../tickets/PriorityControl'
import DateControl from '../../form_controls/DateControl'
import TextAreaControl from '../../form_controls/TextAreaControl'
import TextControl from '../../form_controls/TextControl'
import TextChipListControl from '../../form_controls/TextChipListControl'
import AddPhotoButton from '../../photos/AddPhotoButton'
import { PhotosField } from '../../photos/PhotosField'
import { PhotoDialog } from '../../photos/PhotoDialog'
import { FormikField } from '../../form_controls/FormikField'
import { purgeTicketLocalPhotos } from '../../photos/utils/imageUtils'
import {
  addChecklistPhotosToFormData,
  collateChecklistPhotos,
  collateNewChecklistPhotoComments,
  fixChecklistData
} from '../../../utils/checklist'
import { TagControl } from '../../form_controls/TagsControl'
import { TicketChecklistTab } from '../../tickets/TicketChecklistTab'
import { getExpectedAnswerForFormulaQuestion } from '../../checklists/utils/formulaQuestion'

const styles = (theme: Theme) =>
  createStyles({
    dialogContentWrapper: {
      marginTop: 64,
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%',
      maxWidth: 800,
      [theme.breakpoints.down('xs')]: {
        marginTop: 52
      }
    },
    title: {
      margin: '16px 0'
    },
    galleryHeading: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    appBar: {
      backgroundColor: theme.palette.primary.dark
    },
    checklistHeader: {
      background: theme.palette.primary.main,
      color: '#FFF',
      padding: 16,
      paddingBottom: 8,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    mainActionStyle: {
      backgroundColor: 'white',
      color: '#223d79',
      padding: '5px 15px'
    },
    hsNumber: {
      paddingLeft: 20
    }
  })

export interface INewTicketDefaults extends IChecklistTicketJson {
  question: IChecklistField | null
  emailTo: string
  templateName: string
  checklistDate: string
}

export interface INewTicketDialogProps
  extends IOneplaceLibraryContextProp,
    WithStyles<typeof styles> {
  isOpen: boolean
  franchiseId: number
  imageStorage: IImageStorage
  franchisees: IFranchisees
  site?: ISite

  onClose: () => void
  onCloseTicketPopDialog: () => void
  updateBadge: () => void
  hazardNo: number
  incidentNo: number
  autoSave: boolean
}

export interface INewTicketDialogState {
  loadStatus: LoadStatus
  saveStatus: SaveStatus
  types: ITicketCategoryType[]
  categories: ITicketCategory[]
  tags: ITag[]
  typeOptions: SelectOptions
  categoryOptions: SelectOptions
  selectedCategory?: ITicketCategory | null

  photos: IPhoto[]
  photoDialogMode: 'new' | 'edit'
  photoDialogPhoto: IPhoto | null
  photoDialogOpen: boolean

  submitDialogOpen: boolean
  submitDialogTitle?: string
  submitDialogStage?: SubmitDialogStage
  submitDialogMessage?: string
  submitDialogSubMessage?: string

  questionsNeedRefresh: boolean
  renderProps: IChecklistRenderProps | null
  checklistInitialRenderDone: boolean
  showHiddenFields: boolean
  hasSeenChecklist: boolean

  localId: number
  ticketId: number
  ticket: ITicket
  ticketStatus: TicketStatus

  assignee: AssigneeType | null
  assigneeId: number
  assigneeName: string | null
  franchisees: IFranchisees
  sites: ISites

  prePopulatedSubject: boolean
  prePopulatedContent: boolean
}

function Transition(props: any) {
  return <Slide direction='left' {...props} />
}

export const HSTicketDialog = withStyles(styles)(
  withOneplaceLibraryContext(
    // eslint-disable-next-line react/display-name
    class extends React.Component<
      INewTicketDialogProps,
      INewTicketDialogState
    > {
      fieldValues: IEditTicketFields = {} as IEditTicketFields
      conditionalRulesList: IChecklistConditionalRule[]
      debouncedSave!: () => void
      checklistTabRef: React.RefObject<HTMLDivElement>
      ticketPopRef: React.RefObject<HTMLDivElement>

      constructor(props: any) {
        super(props)
        this.setTicketFromFieldValues = this.setTicketFromFieldValues.bind(this)
        this.onCategoryTypeChanged = this.onCategoryTypeChanged.bind(this)
        this.onCategoryChanged = this.onCategoryChanged.bind(this)
        this.onClose = this.onClose.bind(this)

        this.onPhotoUploaded = this.onPhotoUploaded.bind(this)
        this.onPhotoSaved = this.onPhotoSaved.bind(this)
        this.onPhotoDeleted = this.onPhotoDeleted.bind(this)
        this.onPhotoClicked = this.onPhotoClicked.bind(this)
        this.onPhotoDialogClosed = this.onPhotoDialogClosed.bind(this)

        this.onSubmitClicked = this.onSubmitClicked.bind(this)
        this.submitDialogOnClose = this.submitDialogOnClose.bind(this)
        this.onAssignmentChanged = this.onAssignmentChanged.bind(this)

        this.checklistTabRef = React.createRef()
        this.ticketPopRef = React.createRef()

        this.conditionalRulesList = []

        this.state = {
          loadStatus: 'loading',
          types: [],
          categories: [],
          tags: [],
          typeOptions: [],
          categoryOptions: [],
          selectedCategory: null,

          photos: [],
          photoDialogMode: 'new',
          photoDialogPhoto: null,
          photoDialogOpen: false,

          submitDialogOpen: false,
          submitDialogTitle:
            this.props.ctx.i18next.t('submit') +
            ' ' +
            this.props.ctx.i18next.t('customLabel_ticket'),
          renderProps: {
            groups: []
          },
          questionsNeedRefresh: false,
          checklistInitialRenderDone: false,
          showHiddenFields: false,
          hasSeenChecklist: false,
          ticketId: 0,
          localId: 0,
          assignee: 'site',
          assigneeId: this.props.site?.id as number,
          assigneeName: null,
          sites: { sites: [this.props.site as ISite] },
          franchisees: this.props.franchisees,
          prePopulatedSubject: false,
          prePopulatedContent: false,

          saveStatus: 'none',
          ticket: null as any,
          ticketStatus: 0 as any
        }
        void this.initNewTicket()
      }

      async getSharedDataForNew() {
        return Promise.all([
          //   this.ticketData.getCategories(this.props.franchiseId).getData(),
          //   this.franchiseData.getTags(this.props.franchiseId).getData()
          this.props.ctx.client.getTicketCategories(this.props.franchiseId),
          this.props.ctx.client.getFranchiseTags(this.props.franchiseId)
        ])
      }

      async initNewTicket() {
        try {
          const [categoryData, tags] = await this.getSharedDataForNew()

          let emailTo = ''

          const franchisee: IFranchisee = this.state.franchisees.franchisees[0]

          if (this.state.assignee == 'franchisee') {
            if (
              this.props.ctx.client.getCapabilities().updateTicketEmailField &&
              franchisee.email
            ) {
              emailTo = franchisee.email.replace(';', ',')
            }
          } else if (this.state.assignee == 'site') {
            const site: ISite = this.state.sites.sites[0]
            if (
              this.props.ctx.client.getCapabilities().updateTicketEmailField &&
              site.email
            ) {
              emailTo = site.email.replace(';', ',')
            }
          }

          const date = formatDate('utc', new Date())
          const dueDate = formatDate('iso_dateonly', new Date())
          const defaultTags: ITag[] = []
          tags.tags.forEach((tag) => {
            if (tag.mandatory) {
              defaultTags.push(tag)
            }
          })
          const ticket: ITicket = {
            id: null,
            ticketNo: 0,
            hazardNo: this.props.hazardNo,
            incidentNo: this.props.incidentNo,
            date,
            dueDate,
            tags: defaultTags,
            status: 100,
            statusLabel: 'Pending',
            priority: 200,
            priorityLabel: 'Medium',
            statusProgress: '',
            subject: '',
            content: '',
            emailTo,
            attachments: [],
            category: { id: null } as any,
            franchiseeId: franchisee.id,
            site:
              this.state.assignee == 'site'
                ? {
                    id: this.state.sites.sites[0]!.id,
                    name: this.state.sites.sites[0]!.name
                  }
                : undefined,
            checklist: null
          }
          console.log('ticket', ticket)

          this.setFieldValuesFromTicket(ticket)

          const [types, typeOptions, categoryOptions] = await this.initShared(
            ticket,
            this.state.assignee!,
            categoryData
          )

          await new Promise<void>((resolve) => {
            this.setState(
              {
                loadStatus: 'loaded',
                types,
                categories: categoryData.categories,
                tags: tags.tags,
                typeOptions,
                categoryOptions,
                ticket,
                ticketStatus: ticket.status
              },
              resolve
            )
          })

          this.configureAutoSave()
        } catch (e) {
          logError(e, 'Error while initialising new ticket.')
          this.setState({
            loadStatus: 'load_error'
          })
        }
      }

      async initShared(
        ticket: ITicket,
        assigneeType: AssigneeType,
        categoryData: ITicketCategories
      ): Promise<
        [
          ITicketCategoryType[],
          SelectOptions,
          SelectOptions,
          IChecklistRenderProps | null
        ]
      > {
        const capabs = this.props.ctx.client.getCapabilities()
        let types: ITicketCategoryType[] = []
        let typeOptions: SelectOptions = []
        if (capabs.useTicketType) {
          const typeData = await this.props.ctx.client.getTicketTypes(
            capabs.franchiseId
          )
          types = typeData.ticketTypes
          const ticketCategoryId = (ticket.category && ticket.category.id) || -1
          typeOptions = typeData.ticketTypes.map((type) => {
            // Check if this is the parent category of the selected category
            const catMatch = type.categories.find(
              (cat) => cat.id == ticketCategoryId
            )
            if (catMatch) {
              this.fieldValues.categoryType = String(type.id)
            }
            return {
              label: type.label,
              value: String(type.id)
            }
          })
        }
        const categoryOptions = this.getCategoryOptions(
          categoryData.categories,
          assigneeType,
          types,
          !ticket.id,
          this.fieldValues.categoryType
        )

        let renderProps: IChecklistRenderProps | null = null
        if (ticket.checklist) {
          let attributes: IAttribute[] = []
          if (ticket.checklist.attributes) {
            attributes = ticket.checklist.attributes!
          }
          renderProps = getRenderProps({
            template: ticket.checklist,
            assigneeType,
            assigneeAttributes: attributes
          })
        }

        if (!ticket.attachments) {
          // Make sure attachments is array so photos can be added
          ticket.attachments = []
        }

        return [types, typeOptions, categoryOptions, renderProps]
      }

      componentDidMount() {
        this.configureAutoSave()
      }

      configureAutoSave() {
        if (this.props.autoSave) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          this.debouncedSave = debounce(this.save, CONFIG.autoSaveDelay)
        }
      }

      async save() {
        try {
          const ticket: ITicket = {
            id: null,
            ticketNo: 0,
            incidentNo: this.props.incidentNo,
            hazardNo: this.props.hazardNo,
            date: formatDate('utc', new Date()),
            dueDate: this.fieldValues.dueDate,
            status: 100,
            priority: 200,
            priorityLabel: this.fieldValues.priority,
            statusLabel: 'Pending',
            statusProgress: '',
            subject: this.fieldValues.subject,
            content: this.fieldValues.content,
            attachments: [],
            emailTo: this.fieldValues.emailTo,
            franchiseeId: this.props.site?.franchiseeId as number,
            tags: this.fieldValues.tags,
            category: {
              id: Number(this.fieldValues.category) || -1
            },
            checklist: this.state.ticket.checklist
              ? {
                  ...this.state.ticket.checklist,
                  date: formatDate('utc', new Date())
                }
              : null
          }
          const storedTicket: IStoredTicket = {
            localId: this.state.localId || 0,
            ticketId: 0,
            franchiseeId: this.props.site?.franchiseeId as number,
            siteId: this.props.site?.id || 0,
            ticket
          }
          const newTicketLocalId = await this.props.ctx.client.saveLocalTicket(
            storedTicket
          )
          // update the local ID only when its not yet set
          // to retain the local ID from the DB when update happens
          if (newTicketLocalId && !this.state.localId) {
            this.setState({
              localId: newTicketLocalId
            })
          }
          if (this.state.ticket.checklist) {
            validateGroups(this.state.ticket.checklist, this.state.renderProps!)
          }
        } catch (error) {
          logError(error, 'Error while saving ticket')
        }
      }

      returnTicketDueDateLabel = (
        category: ITicketCategory | undefined | null
      ) => {
        const t = this.props.ctx.i18next.t
        if (category) {
          if (category.dueDateReadOnly) {
            return t('ticket_dueDate_readonly')
          } else {
            return t('ticket_dueDate')
          }
        } else {
          return t('ticket_dueDate')
        }
      }

      onClose() {
        this.props.onClose()
      }

      getCategoryOptions(
        categories: ITicketCategory[],
        assigneeType: AssigneeType,
        types: ITicketCategoryType[],
        isNewTicket: boolean,
        typeId?: string
      ) {
        let categoryOptions: SelectOptions = []
        const type = typeId
          ? types.find((t) => String(t.id) == typeId)
          : undefined
        if (type) {
          // Show only categories of the selected type
          // also filter the categories by entity type
          // and remove ticketPopOnly categories
          const catIds = type.categories.map((cat) => cat.id)
          categoryOptions = categories
            .filter((cat) => catIds.includes(cat.id))
            .filter(
              (cat) =>
                (cat.ticketEntitySetting != 'S' &&
                  assigneeType == 'franchisee') ||
                (cat.ticketEntitySetting != 'F' && assigneeType == 'site')
            )
            .filter((cat) => !cat.ticketPopOnly || !isNewTicket)
            .map((cat) => ({ label: cat.label!, value: String(cat.id) }))
        } else {
          // Show all categories
          // also filter the categories by entity type
          // and remove ticketPopOnly categories
          categoryOptions = categories
            .filter(
              (cat) =>
                (cat.ticketEntitySetting != 'S' &&
                  assigneeType == 'franchisee') ||
                (cat.ticketEntitySetting != 'F' && assigneeType == 'site')
            )
            .filter((cat) => !cat.ticketPopOnly || !isNewTicket)
            .map((cat) => ({ label: cat.label!, value: String(cat.id) }))
        }
        return categoryOptions
      }

      setFieldValuesFromTicket(ticket: ITicket) {
        const values = this.fieldValues
        values.dueDate = ticket.dueDate
        values.category = (ticket.category && String(ticket.category.id)) || ''
        values.categoryName = (ticket.category && ticket.category.name) || ''
        values.priority = ticket.priorityLabel as PriorityOption
        values.tags = ticket.tags || []
        values.subject = ticket.subject
        values.content = ticket.content
        values.sendEmail = ticket.sendEmail || true
        values.emailTo = ticket.emailTo
        values.status = ticket.status
        values.resolverIds = []
        values.statusComment = ''
        values.cancelTicket = ticket.cancelTicket || false
      }

      setTicketFromFieldValues(values: IEditTicketFields) {
        Object.assign(this.fieldValues, values)
        const ticket = this.state.ticket
        // Sync state.ticket with form data
        ticket.dueDate = values.dueDate
        ticket.category = {
          id: Number(values.category)
        }
        ticket.priorityLabel = values.priority
        ticket.tags = values.tags
        ticket.subject = values.subject
        ticket.content = values.content
        ticket.sendEmail = values.sendEmail
        ticket.emailTo = values.emailTo
        ticket.status = values.status
        if (ticket.gateKeeper && ticket.gateKeeper.categoryResolvers) {
          ticket.gateKeeper.resolvers = convertSelectedResolverIdsToResolvers(
            ticket.gateKeeper.categoryResolvers,
            values.resolverIds
          )
        }
        ticket.statusComment = values.statusComment
        ticket.cancelTicket = values.cancelTicket
        if (this.props.autoSave) {
          if (this.state.saveStatus != 'saving') {
            this.setState({
              saveStatus: 'saving'
            })
          }
          this.debouncedSave()
        }

        if (ticket.checklist) {
          // sync checklist name with ticket subject
          ticket.checklist.name = values.subject
        }
      }

      onCategoryTypeChanged(
        oldValue: any,
        newValue: any,
        form: FormikProps<any>
      ) {
        if (oldValue != newValue) {
          const categoryOptions = this.getCategoryOptions(
            this.state.categories,
            this.state.assignee!,
            this.state.types,
            true,
            newValue
          )
          form.setFieldValue('category', '')
          this.setState({
            categoryOptions
          })
        }
        // reseting the checklist value to null so that the checklist
        // at the bottom of the ticket will disappear if it exists
        this.setState((prevState) => ({
          ticket: {
            ...prevState.ticket,
            checklist: null
          },
          hasSeenChecklist: false
        }))
      }

      onCategoryChanged = async (
        oldValue: any,
        newValue: any,
        form: FormikProps<any>
      ) => {
        if (oldValue != newValue) {
          const category = this.state.categories.find(
            (cat) => cat.id == Number(newValue)
          )

          if (
            category &&
            (category.checklist || category.templateChecklistId)
          ) {
            // if user is online, categories won't contain full checklist loaded
            // (unless user has already selected the category previously in the dropdown)
            if (!category.checklist && category.templateChecklistId) {
              const franchiseeId =
                this.state.assignee === 'franchisee'
                  ? this.state.assigneeId
                  : getSiteFranchiseeId(this.props.site!)
              const checklist =
                await this.props.ctx.client.getChecklistTemplate(
                  this.props.ctx.client.getCapabilities().franchiseId,
                  franchiseeId,
                  category.templateChecklistId
                )
              category.checklist = checklist
            }

            if (!category.checklist) return

            const defaultSubject =
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              category.checklist.name + ' - ' + this.state.assigneeName
            const ticket = this.state.ticket
            ticket.checklist = deepCopy(category.checklist)
            // Set checklist fields
            ticket.checklist.name = defaultSubject
            ticket.checklist.date = ticket.date
            ticket.checklist.site = ticket.site || null

            const renderProps: IChecklistRenderProps | null =
              this.getPropsForChecklist(category)

            this.findConditionalRulesFromTemplate(ticket.checklist)

            this.setState(
              {
                ticket,
                renderProps,
                prePopulatedSubject: category.prepopulatingSubject || false,
                prePopulatedContent: category.prepopulatingContent || false,
                hasSeenChecklist: false
              },
              () => {
                form.setValues({
                  ...this.fieldValues,
                  category: category.id,
                  subject: category.prepopulatingSubject
                    ? defaultSubject
                    : null,
                  content: category.prepopulatingContent ? defaultSubject : null
                })
              }
            )
          } else {
            form.setValues({
              ...this.fieldValues,
              category: '',
              subject: '',
              content: ''
            })
            const ticket = this.state.ticket
            // IMPORTANT: Possible data loss - maybe we should warn?
            // - this matches the current app behaviour though
            ticket.checklist = null
            this.setState({
              ticket,
              renderProps: null,
              prePopulatedSubject: false,
              prePopulatedContent: false,
              hasSeenChecklist: false
            })
          }
        }
      }

      onPhotoUploaded(photos: IPhoto[]) {
        this.setState({
          photoDialogMode: 'new',
          photoDialogPhoto: photos[0],
          photoDialogOpen: true
        })
      }

      onPhotoSaved(photo: IPhoto) {
        if (this.state.photoDialogMode == 'new') {
          this.state.photos.push(photo)
        }
        this.setState({
          photoDialogOpen: false
        })
      }

      onPhotoDeleted(photo: IPhoto) {
        if (this.state.photos) {
          const photoIdx = this.state.photos.findIndex(
            (storedPhoto) => storedPhoto.url == photo.url
          )
          if (photoIdx > -1) {
            // TODO: Delete photo from storage
            this.state.photos.splice(photoIdx, 1)
          }
        }
        this.setState({
          photoDialogOpen: false
        })
      }

      onPhotoClicked(photo: IPhoto) {
        this.setState({
          photoDialogMode: 'edit',
          photoDialogPhoto: photo,
          photoDialogOpen: true
        })
      }

      onPhotoDialogClosed() {
        this.setState({
          photoDialogPhoto: null,
          photoDialogOpen: false
        })
      }

      findConditionalRulesFromTemplate = (
        checklist: IChecklist | null | undefined
      ) => {
        if (!checklist) {
          return
        }
        checklist.groups.forEach((group, _groupindex) => {
          group.fields
            .filter((f) => f.conditionalRule != null)
            .forEach((field) =>
              this.conditionalRulesList.push(field.conditionalRule!)
            )
        })
      }

      validateConditionalQuestion = (
        newValue: string,
        question: IChecklistField | null
      ) => {
        if (question == null) {
          // no conditional question change, don't need to refresh page
          this.setState({
            questionsNeedRefresh: false
          })
          return
        }

        const filteredConditionalRules: IChecklistConditionalRule[] = []
        question.conditions!.forEach((conditionId) => {
          this.conditionalRulesList.forEach(
            (conditionRule, _conditionalRuleIdx) => {
              conditionRule.conditions!.forEach((condition, _conditionIdx) => {
                if (condition.id == conditionId) {
                  condition.applied = hasConditionApplied(
                    newValue,
                    question,
                    condition
                  )
                  if (
                    filteredConditionalRules.includes(conditionRule) === false
                  ) {
                    filteredConditionalRules.push(conditionRule)
                  }
                }
              })
            }
          )
        })
        filteredConditionalRules.forEach((conditionalRule) => {
          this.refreshConditionalRuleAndSubQuestions(conditionalRule)
        })

        // validating the groups here so that updateQuestion numbers gets
        // the most recent change
        const newRenderProps = validateGroups(
          this.state.ticket.checklist!,
          this.state.renderProps as IChecklistRenderProps
        )
        this.setState({
          renderProps: newRenderProps
        })

        // update question number
        const renderProps = updateQuestionNumbers(
          this.state.ticket.checklist!,
          this.state.renderProps as IChecklistRenderProps
        )
        this.setState({
          questionsNeedRefresh: filteredConditionalRules.length > 0,
          renderProps
        })
      }

      refreshConditionalRuleAndSubQuestions(
        conditionalRule: IChecklistConditionalRule
      ) {
        if (!this.state.ticket.checklist) {
          return
        }

        const currentGroup = findChecklistGroupById(
          conditionalRule.groupId,
          this.state.ticket.checklist
        )
        const showFieldFlag = isConditionalRuleShow(
          conditionalRule,
          this.conditionalRulesList
        )
        if (currentGroup) {
          currentGroup.fields.forEach((field) => {
            if (conditionalRule.conditionalQuestions.includes(field.id)) {
              field.hidden = !showFieldFlag
              if (field.type === 'dynamicdatalist') {
                updateDynamicDatalistQuestions(field)
              }
              if (field.type == 'conditionalRule') {
                this.refreshConditionalRuleAndSubQuestions(
                  field.conditionalRule!
                )
              }
            }
          })
        }
      }

      refreshFormulaQuestions = (inputQuestion: IChecklistField) => {
        const formulaQuestions = getExpectedAnswerForFormulaQuestion(
          inputQuestion,
          undefined,
          this.state.ticket.checklist!
        )
        if (formulaQuestions && formulaQuestions.length > 0) {
          const renderProps = refreshFormulaQuestions(
            this.state.ticket.checklist!,
            this.state.renderProps!,
            formulaQuestions
          )
          this.setState({
            questionsNeedRefresh: true,
            renderProps
          })
        }
      }

      async onTicketSubmitted(ticketId: number, ticket: ITicketUpdate) {
        // Update ticket id (used by email dialog)
        this.setState({
          ticketId
        })
        // Once ticket submitted, we should remove local version (if it exists)
        if (this.state.localId) {
          await this.props.ctx.client.removeLocalTicket(this.state.localId)
        }
        // We should also remove locally stored photos
        try {
          // reconstructing the ticket here as purgeTicketLocalPhotos function needs an ITicket type
          // purgeTicketLocalPhotos only cares about the attachments just need to provide dummy
          // key value pair to satisfy the type that the function requires.
          const newTicket = {
            ...ticket,
            status: 0,
            ticketNo: 0,
            date: '',
            priority: 0,
            statusLabel: '',
            statusProgress: '',
            priorityLabel: '',
            subject: '',
            content: '',
            attachments: this.state.photos,
            franchiseeId: 0,
            ...(ticket.checklist
              ? { checklist: ticket.checklist }
              : { checklist: null })
          }
          await purgeTicketLocalPhotos(newTicket, this.props.imageStorage)
        } catch (e) {
          logError(
            e,
            'Error occured while purging locally stored photos for ticket'
          )
        }
        this.setState({
          localId: 0,
          ticketId
        })
      }

      async onSubmitClicked() {
        const t = this.props.ctx.i18next.t

        this.setState({
          submitDialogOpen: true,
          submitDialogStage: 'submitting',
          submitDialogMessage: '',
          submitDialogSubMessage: ''
        })

        const errors: string[] = []
        if (
          this.fieldValues.category == 'undefined' ||
          !this.fieldValues.category
        ) {
          errors.push(t('ticket_error_must_enter_category'))
        } else if (!this.fieldValues.subject) {
          errors.push(t('ticket_error_must_enter_subject'))
        } else if (!this.fieldValues.content) {
          errors.push(t('ticket_error_must_enter_note'))
        }
        if (errors.length) {
          this.setState({
            submitDialogTitle: t('submit') + ' ' + t('customLabel_ticket'),
            submitDialogOpen: true,
            submitDialogStage: 'submit_error',
            submitDialogMessage: errors[0],
            submitDialogSubMessage: ''
          })
          return
        }
        const ticket: ITicketUpdate = {
          id: null,
          hazardNo: this.props.hazardNo,
          incidentNo: this.props.incidentNo,
          dueDate: this.fieldValues.dueDate,
          priorityLabel: this.fieldValues.priority,
          subject: this.fieldValues.subject,
          content: this.fieldValues.content,
          emailTo: this.fieldValues.emailTo,
          tags: this.fieldValues.tags,
          category: {
            id: Number(this.fieldValues.category) || -1
          },
          ...(this.state.ticket.checklist && {
            checklist: {
              ...this.state.ticket.checklist,
              date: formatDate('utc', new Date())
            }
          })
        }

        if (this.props.site) {
          ticket.site = {
            id: this.props.site.id,
            name: this.props.site.name
          }
        }

        try {
          const newTicketId = await this.submitTicket(
            this.state.franchisees.franchisees[0].id,
            ticket,
            this.state.photos,
            this.props.imageStorage
          )
          console.log('Got response', newTicketId)
          await this.onTicketSubmitted(newTicketId, ticket)
          this.props.updateBadge()
          this.setState({
            submitDialogStage: 'submit_successful',
            submitDialogMessage: t('ticket_submit_successful')
          })
        } catch (e) {
          if (e instanceof UserFacingError) {
            this.setState({
              submitDialogStage: 'submit_error',
              submitDialogMessage: t('ticket_submit_problem'),
              submitDialogSubMessage: e.message
            })
          } else if (e instanceof NetworkError) {
            this.setState({
              submitDialogStage: 'submit_error',
              submitDialogMessage: t('ticket_network_error'),
              submitDialogSubMessage: undefined
            })
          } else {
            logError(e, 'Unexpected error while submitting ticket')
            this.setState({
              submitDialogStage: 'submit_error',
              submitDialogMessage: t('ticket_submit_error'),
              submitDialogSubMessage: undefined
            })
          }
        }
      }

      submitDialogOnClose() {
        this.setState({ submitDialogOpen: false })
        if (this.state.submitDialogStage == 'submit_successful') {
          this.props.onClose()
        }
      }

      getPropsForChecklist(selectedCategory: any) {
        let renderProps = null
        if (selectedCategory?.checklist) {
          renderProps = getRenderProps({
            template: selectedCategory?.checklist,
            assigneeType: this.state.assignee as AssigneeType,
            assigneeAttributes:
              this.state.assignee === 'site'
                ? this.state.sites.sites[0].attributes
                : this.state.franchisees.franchisees[0].attributes
          })
          renderProps = updateQuestionNumbers(
            selectedCategory?.checklist,
            renderProps
          )
        }
        return renderProps
      }

      async submitTicket(
        franchiseeId: number,
        ticket: ITicketUpdate,
        photos: IPhoto[],
        imageStorage: IImageStorage
      ) {
        const ticketData = deepCopy(ticket)

        let checklistPhotos: ChecklistPhotoList = []
        if (ticketData.checklist) {
          checklistPhotos = collateChecklistPhotos(ticketData.checklist)

          // Collate new photo comments
          collateNewChecklistPhotoComments(
            checklistPhotos,
            ticketData.checklist
          )

          fixChecklistData(ticketData.checklist)
        }

        const ticketPostData = new FormData()
        ticketPostData.append('ticket', JSON.stringify({ ticket: ticketData }))

        // Append ticket photo data
        for (const photo of photos) {
          // Make sure it is a new (locally-stored) photo
          if (photo.url.startsWith(STORED_IMAGE_PREFIX)) {
            const photoData = await imageStorage.getImageData(photo.url)

            let takenDate = photo.photoTakenDate || ''
            if (takenDate) {
              takenDate = formatDate('exif', takenDate)
            }
            ticketPostData.append('attachment[]', photoData, photo.fileName)
            ticketPostData.append(photo.fileName, photo.comment || '')
            ticketPostData.append(photo.fileName + 'photoTakenDate', takenDate)
          }
        }

        await addChecklistPhotosToFormData(
          imageStorage,
          checklistPhotos,
          ticketPostData,
          'checklistAttachment[]'
        )

        console.log('Sending ticket', ticketData)
        const newTicketId = await this.props.ctx.client.saveTicket(
          this.props.ctx.client.getCapabilities().franchiseId,
          franchiseeId,
          ticketPostData,
          ticket.id!,
          300000 // 2018-11-27: changed timeout for ticket to 5Min
        )

        return newTicketId
      }

      // The following code is not working because the AssignmentForm always resets the selection
      onAssignmentChanged = (assignment: IAssignment) => {
        if (assignment.assignee === 'franchisee') {
          this.setState({
            assignee: 'franchisee',
            assigneeId: this.state.franchisees.franchisees[0].id
          })
        } else {
          this.setState({
            assignee: 'site',
            assigneeId: this.state.sites.sites[0].id
          })
        }
      }

      setAssigneeName = () => {
        const franchiseeName = this.state.franchisees.franchisees[0].name

        if (this.state.assignee === 'site') {
          if (
            !this.props.ctx.client.getCapabilities().retailOrganisation &&
            !this.props.ctx.client.getCapabilities().useAutocomplete
          ) {
            this.setState({
              assigneeName: `${this.props.ctx.i18next.t(
                'customLabel_site'
              )} : ${franchiseeName}--${this.state.sites.sites[0].name}`
            })
          } else {
            this.setState({
              assigneeName: `${this.props.ctx.i18next.t(
                'customLabel_site'
              )} : ${this.state.sites.sites[0].name}`
            })
          }
        } else {
          this.setState({
            assigneeName:
              this.props.ctx.i18next.t('customLabel_franchisee') +
              ': ' +
              franchiseeName
          })
        }
      }

      onContinueEditing = () => {
        if (this.state.submitDialogStage === 'submit_error') {
          this.setState({
            submitDialogOpen: false
          })
        } else if (this.state.submitDialogStage === 'submit_successful') {
          this.props.onCloseTicketPopDialog()
        }
      }

      render() {
        const t = this.props.ctx.i18next.t

        const { hazardNo, incidentNo } = this.props

        const hsNoLabel =
          hazardNo && hazardNo > 0
            ? `${t('customLabel_hazard')} no: ${hazardNo}`
            : incidentNo && incidentNo > 0
            ? `${t('customLabel_incident')} no: ${incidentNo}`
            : ''

        const tabs: ITabDefinition[] = [
          {
            name: 'details',
            label: t('ticket_details'),
            component: <></>
          }
        ]

        return (
          <Dialog
            fullScreen
            open={this.props.isOpen}
            TransitionComponent={Transition}
            PaperProps={{ style: { background: '#eee' } }}
          >
            <AppBar position='fixed' className={this.props.classes.appBar}>
              <Toolbar>
                <IconButton
                  color='inherit'
                  onClick={this.props.onClose}
                  aria-label='Close'
                >
                  <CloseIcon />
                </IconButton>
                <Typography
                  variant='h6'
                  color='inherit'
                  style={{ flex: 1, whiteSpace: 'normal' }}
                >
                  {t('customLabel_ticket')}
                </Typography>
                {this.state.ticket &&
                  this.state.ticket.category &&
                  this.state.ticket.category.id > 0 && (
                    <Button
                      color='inherit'
                      onClick={
                        !this.state.ticket.checklist ||
                        (this.state.ticket.checklist &&
                          this.state.hasSeenChecklist)
                          ? this.onSubmitClicked
                          : () => {
                              this.checklistTabRef.current?.scrollIntoView({
                                inline: 'start',
                                behavior: 'smooth'
                              })
                              this.setState({ hasSeenChecklist: true })
                            }
                      }
                      style={{
                        backgroundColor: 'white',
                        color: '#223d79',
                        padding: '5px 15px'
                      }}
                    >
                      {this.state.ticket.checklist &&
                      !this.state.hasSeenChecklist
                        ? 'View checklist'
                        : `${t('submit')} ${t('customLabel_ticket')}`}
                    </Button>
                  )}
              </Toolbar>
            </AppBar>
            <div
              className={this.props.classes.dialogContentWrapper}
              ref={this.ticketPopRef}
            >
              {this.state.loadStatus == 'loading' && (
                <PageLoader loading={true} />
              )}
              {this.state.loadStatus == 'loaded' && (
                <>
                  {!this.state.assigneeName && (
                    <div>
                      <Card style={{ marginBottom: 20, overflow: 'visible' }}>
                        <CardHeader
                          title={`${t('new')} ${t('customLabel_ticket')}`}
                        />
                        <CardContent style={{ paddingTop: 0 }}>
                          <AssignmentForm
                            entityAssignment='both'
                            useAutocomplete={
                              this.props.ctx.client.getCapabilities()
                                .useAutocomplete
                            }
                            franchiseesShown={
                              this.props.ctx.client.getCapabilities()
                                .myFranchisees
                            }
                            franchisees={this.state.franchisees}
                            sites={this.state.sites}
                            assignee={this.state.assignee}
                            assigneeId={this.state.assigneeId}
                            onAssignmentChanged={this.onAssignmentChanged}
                          />
                        </CardContent>
                        <div style={{ padding: 12, textAlign: 'right' }}>
                          <Button color='primary' onClick={this.props.onClose}>
                            {t('cancel')}
                          </Button>
                          <Button
                            color='primary'
                            key={`${this.state.assigneeId}`}
                            onClick={this.setAssigneeName}
                          >{`${t('create')} ${t(
                            'customLabel_ticket'
                          )}`}</Button>
                        </div>
                      </Card>
                    </div>
                  )}
                  {this.state.assigneeName && (
                    <>
                      <div className={this.props.classes.checklistHeader}>
                        <div>
                          <Typography
                            gutterBottom
                            variant='h5'
                            component='span'
                            style={{ marginTop: 8 }}
                          >
                            {`${t('new')} ${t('customLabel_ticket')}`}
                          </Typography>
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Typography
                              variant='body1'
                              color='inherit'
                              id='assigneeName'
                            >
                              {this.state.assigneeName}
                            </Typography>
                            <Typography
                              variant='body1'
                              color='inherit'
                              id='hazardNoLabel'
                              className={this.props.classes.hsNumber}
                            >
                              {hsNoLabel}
                            </Typography>
                          </div>
                        </div>
                        <Button
                          color='primary'
                          variant='text'
                          size='small'
                          name='toggleHiddenFields'
                          style={{
                            maxHeight: 32,
                            color: '#223d79',
                            backgroundColor: 'white'
                          }}
                          onClick={() => {
                            this.setState({
                              showHiddenFields: !this.state.showHiddenFields
                            })
                          }}
                        >
                          <Typography
                            component='span'
                            style={{ marginRight: 5, fontSize: 12 }}
                          >
                            {`${
                              this.state.showHiddenFields
                                ? 'Hide'
                                : 'Show hidden'
                            } fields`}
                          </Typography>
                          {this.state.showHiddenFields ? (
                            <VisibilityOff fontSize='small' />
                          ) : (
                            <Visibility fontSize='small' />
                          )}
                        </Button>
                      </div>
                      <TabsComponent
                        color='light'
                        compact={true}
                        tabs={tabs}
                        hasDetailsTab={false}
                      />

                      <Card style={{ marginTop: 20 }}>
                        <CardContent style={{ overflowY: 'auto' }}>
                          <Formik
                            initialValues={this.fieldValues}
                            onSubmit={(_values, _actions) => {
                              return
                            }}
                            validate={this.setTicketFromFieldValues}
                            validateOnBlur={false}
                            render={(_formProps) => (
                              <Form>
                                <Grid container spacing={2}>
                                  {this.props.ctx.client.getCapabilities()
                                    .useTicketType && (
                                    <FormikField
                                      name='categoryType'
                                      label={t('ticket_categoryType')}
                                      component={SelectControl}
                                      options={this.state.typeOptions}
                                      dropdown
                                      onFieldChange={this.onCategoryTypeChanged}
                                      gridProps={{ xs: 12, sm: 6 }}
                                    />
                                  )}
                                  <FormikField
                                    name='category'
                                    label={t('ticket_category')}
                                    component={SelectControl}
                                    onFieldChange={this.onCategoryChanged}
                                    options={this.state.categoryOptions}
                                    dropdown
                                    gridProps={{ xs: 12, sm: 6 }}
                                  />
                                  <FormikField
                                    name='priority'
                                    label={t('ticket_priority')}
                                    component={PriorityControl}
                                    gridProps={{ xs: 12, sm: 6 }}
                                  />
                                  <FormikField
                                    name='dueDate'
                                    label={this.returnTicketDueDateLabel(
                                      this.state.selectedCategory
                                    )}
                                    component={DateControl}
                                    dateFormat={
                                      this.props.ctx.client.getCapabilities()
                                        .dateFormat
                                    }
                                    disabled={
                                      !!this.state.selectedCategory &&
                                      this.state.selectedCategory
                                        .dueDateReadOnly
                                    }
                                    gridProps={{ xs: 12 }}
                                  />
                                  <FormikField
                                    name='tags'
                                    label={t('tags')}
                                    component={TagControl}
                                    tagOptions={this.state.tags}
                                    gridProps={{ xs: 12, sm: 6 }}
                                  />
                                  {(this.state.ticket.id ||
                                    !this.state.ticket.checklist ||
                                    !this.state.prePopulatedSubject) && (
                                    <FormikField
                                      name='subject'
                                      label={t('ticket_subject')}
                                      component={TextControl}
                                      maxLength={127}
                                      gridProps={{ xs: 12 }}
                                    />
                                  )}
                                  {(this.state.ticket.id ||
                                    !this.state.ticket.checklist ||
                                    !this.state.prePopulatedContent) && (
                                    <FormikField
                                      name='content'
                                      label={t('ticket_content')}
                                      component={TextAreaControl}
                                      gridProps={{ xs: 12 }}
                                    />
                                  )}
                                  {this.state.showHiddenFields &&
                                    this.state.ticket.checklist && (
                                      <>
                                        {this.state.prePopulatedSubject && (
                                          <FormikField
                                            name='subject'
                                            label={t('ticket_subject')}
                                            component={TextControl}
                                            maxLength={127}
                                            gridProps={{ xs: 12 }}
                                          />
                                        )}
                                        {this.state.prePopulatedContent && (
                                          <FormikField
                                            name='content'
                                            label={t('ticket_content')}
                                            component={TextAreaControl}
                                            gridProps={{ xs: 12 }}
                                          />
                                        )}

                                        <FormikField
                                          name='emailTo'
                                          label={t('ticket_emailTo')}
                                          component={TextChipListControl}
                                          gridProps={{ xs: 12 }}
                                        />
                                      </>
                                    )}
                                </Grid>
                              </Form>
                            )}
                          />
                          {!this.state.ticket.checklist && (
                            <>
                              <div
                                className={this.props.classes.galleryHeading}
                              >
                                <Typography
                                  variant='subtitle1'
                                  style={{ fontSize: 18 }}
                                >
                                  {t('gallery')}
                                </Typography>
                                <AddPhotoButton
                                  env={this.props.ctx.env}
                                  controlId={'ticket-photo'}
                                  className=''
                                  imageStorage={this.props.imageStorage}
                                  onPhotoUploaded={this.onPhotoUploaded}
                                  allowMultipleFiles={false}
                                />
                              </div>
                              {this.state.photos &&
                                this.state.photos.length > 0 && (
                                  <PhotosField
                                    photos={this.state.photos}
                                    onPhotoClicked={this.onPhotoClicked}
                                  />
                                )}
                            </>
                          )}
                        </CardContent>
                      </Card>
                    </>
                  )}
                </>
              )}
              {this.state.loadStatus == 'loaded' &&
                this.state.ticket?.checklist &&
                this.state.renderProps && (
                  <div style={{ marginTop: 15 }} ref={this.checklistTabRef}>
                    <TicketChecklistTab
                      key={this.state.ticket.checklist.id}
                      checklist={this.state.ticket.checklist}
                      renderProps={this.state.renderProps}
                      onChecklistChange={() => {
                        this.setState({ hasSeenChecklist: true })
                        validateGroups(
                          this.state.ticket.checklist!,
                          this.state.renderProps as IChecklistRenderProps
                        )
                        if (this.props.autoSave) {
                          this.debouncedSave()
                        }
                      }}
                      validateConditionalQuestion={
                        this.validateConditionalQuestion
                      }
                      questionsNeedRefresh={this.state.questionsNeedRefresh}
                      disableTabs={false}
                      refreshFormulaQuestions={this.refreshFormulaQuestions}
                    />
                  </div>
                )}
            </div>
            {
              <SubmitStatusDialog
                isOpen={this.state.submitDialogOpen}
                title={this.state.submitDialogTitle!}
                stage={this.state.submitDialogStage!}
                message={this.state.submitDialogMessage}
                subMessage={this.state.submitDialogSubMessage}
                onClose={this.onContinueEditing}
                customButtonAction={this.props.onCloseTicketPopDialog}
                customButtonActionLabel='Exit'
              />
            }
            {this.state.photoDialogOpen && (
              <PhotoDialog
                isOpen={this.state.photoDialogOpen}
                mode={this.state.photoDialogMode}
                photo={this.state.photoDialogPhoto!}
                imageStorage={this.props.imageStorage}
                onClose={this.onPhotoDialogClosed}
                onSave={this.onPhotoSaved}
                onDelete={this.onPhotoDeleted}
                showTakePhotoButton={false}
              />
            )}
          </Dialog>
        )
      }
    }
  )
)
